<template>
  <v-row dense class="mt-3">
    <v-col cols="12" sm="6" lg="6" md="6">
      <v-card outlined class="rounded-card" style="height: 100%;">
        <v-subheader class="font-weight-bold text--primary">Local de entrega</v-subheader>
        <v-divider/>
        <v-card-text>
          <px-detalhes-locais-entrega :locais-entrega="cotacao.locaisEntrega"
            :show-codigo-interno="false"/>
        </v-card-text>
      </v-card>
    </v-col>
    <v-col cols="12" sm="6" lg="6" md="6">
      <v-card outlined class="rounded-card">
        <v-subheader class="font-weight-bold text--primary">Local de faturamento</v-subheader>
        <v-divider/>
        <v-card-text>
          <px-detalhes-comprador :comprador="cotacao.comprador"/>
        </v-card-text>
      </v-card>
    </v-col>
  </v-row>
</template>
<script>
export default {
  props: {
    cotacao: Object,
  },
};
</script>
